import 'babel-polyfill'  //兼容
import Vue from 'vue'
import router from './router'
import App from './App.vue'

import './plugins/vueamap.js' //  vue-amap 高德地图
import './plugins/element.js' //  elemnt组件
import {post,get,put,deletes,toJson,isEmpty} from './plugins/http.js' // 请求方式中间件
import {api} from './plugins/api.js'  // API 链接
import {formatDate,formatGoods} from './plugins/function.js' // 公共方法
import '../public/fonts/iconfont.css' // 阿里图标
import '../public/font-awesome/css/font-awesome.min.css' //引入font-awesome
import '../public/style.css' // 公共CSS
import '../public/base.css' // 大商创公共CSS
import '../public/css.css' // 大商创公共CSS
import 'default-passive-events'
import htmlToPdf from '@/plugins/htmlToPdf'





import skeleton from 'vue-skeleton-component' // 骨架

import MetaInfo from 'vue-meta-info';  //标题关键词描述

// import { pcaa } from 'area-data-vue';
// import 'area-linkage-vue/dist/index.css';
// import AreaLinkageVue from 'area-linkage-vue';
// Vue.prototype.$pcaa = pcaa;

import vshare from 'vshare'   //百度分享

import LuckDraw from 'vue-luck-draw' //转盘/九宫格抽奖


import md5 from 'js-md5'; // md5
// import store from './store' // VUEX

import Print from 'vue-print-nb'; //打印组件

import VuePhotoZoomPro from 'vue-photo-zoom-pro'

// import scroll from 'vue-seamless-scroll'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'

//定义全局变量
Vue.prototype.$api=api;
Vue.prototype.$post=post;
Vue.prototype.$get=get;
Vue.prototype.$put=put;
Vue.prototype.$delete=deletes;
Vue.prototype.$toJson=toJson;
Vue.prototype.$isEmpty=isEmpty;
Vue.prototype.$md5=md5;
Vue.prototype.$formatGoods=formatGoods;
Vue.prototype.$platId='1';
Vue.prototype.$weburl='https://www.sckxyy.com/';
Vue.prototype.$mweburl='https://m.sckxyy.com/';
// Vue.prototype.$WebSocket='ws://222.211.65.10:8759/websocket/';
// Vue.prototype.$WebSocket='ws://192.168.55:8759/websocket/';
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.prototype.$scrollTo = (x = 450, y = 0, type = 'smooth') => {
	window.scrollTo({
		top: x,
		left: y,
		behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
	})
}

Vue.use(htmlToPdf)


// 时间格式化
Vue.filter('formatDate', function (time) {
    var date = new Date(time*1000);
    return formatDate(date, 'yyyy-MM-dd hh:mm');
});

Vue.filter('formatDateAuto', function (time,str) {
    var date = new Date(time*1000);
    return formatDate(date, str);
});


/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.config.productionTip = false

Vue.use(skeleton); // 骨架
Vue.use(vshare);   //百度分享
Vue.use(MetaInfo);  //标题关键词
Vue.use(Print);  //打印
Vue.use(LuckDraw); //转盘/九宫格抽奖
// Vue.use(scroll);



Vue.use(VuePhotoZoomPro);
//全局修改默认配置，点击空白处不能关闭弹窗
// ElementUI.Dialog.props.closeOnClickModal.default = false
// Vue.use(ElementUI)

// Vue.use(AreaLinkageVue) //城市选择

// 地区选择
// import VDistpicker from 'v-distpicker'
// Vue.component('v-distpicker', VDistpicker)

// 跳转后返回顶部
router.afterEach(() => {
    window.scrollTo(0,0);
})

//正整数
Vue.directive('enterNumber', {
    inserted: function (el) {
      el.addEventListener("keypress",function(e){
        e = e || window.event;
        let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
        let re = /\d/;
        if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
          if(e.preventDefault){
            e.preventDefault();
          }else{
            e.returnValue = false;
          }
        }
      });
    }
  });
  

  

new Vue({
    router,
    // store,
    render: h => h(App)
}).$mount('#app')
